import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';

import usersSearchForm from './usersSearchForm';
import userScreen from './userScreen';

import { getUserId } from '../../helpers/common';

const byId = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_USERS_SUCCESS:
      return action.byId;
    case actionTypes.SEARCH_SUB_CLIENT_USERS_SUCCESS:

      let updateState = state;
      action.data.map(data => {
        if (!Object.keys(updateState).includes(data.email)) {
          updateState[data.email] = data
        }
      })

      return updateState
    case actionTypes.DEACTIVATE_USER_SUCCESS:
    case actionTypes.ACTIVATE_USER_SUCCESS:
      return {
        ...state,
        [action.userId]: {
          ...state[action.userId],
          status: action.status
        }
      };
    default:
      return state;
  }
}

const ids = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SEARCH_USERS_SUCCESS:
      return action.ids
    case actionTypes.SEARCH_SUB_CLIENT_USERS_SUCCESS:

      let updateState = state;
      action.data.map(data => {
        if (!state.includes(data.email)) {
          updateState.push(data.email)
        }
      })

      return updateState
    default:
      return state;
  }
}

const isSearching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_USERS_REQUEST:
    case actionTypes.SEARCH_SUB_CLIENT_USERS_REQUEST:
      return true;
    case actionTypes.SEARCH_USERS_FAILURE:
    case actionTypes.SEARCH_USERS_SUCCESS:
    case actionTypes.SEARCH_SUB_CLIENT_USERS_SUCCESS:
    case actionTypes.SEARCH_SUB_CLIENT_USERS_FAILURE:
      return false;
    default:
      return state;
  }
}

const isSaving = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CREATE_USER_REQUEST:
    case actionTypes.UPDATE_USER_REQUEST:
      return true;
    case actionTypes.CREATE_USER_SUCCESS:
    case actionTypes.CREATE_USER_FAILURE:
    case actionTypes.UPDATE_USER_SUCCESS:
    case actionTypes.UPDATE_USER_FAILURE:
      return false;
    default:
      return state;
  }
}

const isDeactivating = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DEACTIVATE_USER_REQUEST:
      return true;
    case actionTypes.DEACTIVATE_USER_SUCCESS:
    case actionTypes.DEACTIVATE_USER_FAILURE:
      return false;
    default:
      return state;
  }
}

const isActivating = (state = false, action) => {
  switch (action.type) {
    case actionTypes.ACTIVATE_USER_REQUEST:
      return true;
    case actionTypes.ACTIVATE_USER_FAILURE:
    case actionTypes.ACTIVATE_USER_SUCCESS:
      return false;
    default:
      return state;
  }
}

const selectedUserId = (state = "", action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER:
      return "";
    case actionTypes.SELECT_USER:
      return action.user.email;
    default:
      return state;
  }
}

const currentUser = (state = [], action) => {
  switch (action.type) {
    case actionTypes.CURRENT_USER_SUCCESS:
      console.log(action)
      return action;
    default:
      return state;
  }
}

export default combineReducers({
  currentUser,
  byId,
  ids,
  isSearching,
  isSaving,
  isDeactivating,
  isActivating,
  usersSearchForm,
  selectedUserId,
  userScreen
});

const getCurrentState = state => state.users;
const getSystemCurrentState = state => state.system;

export const getUsers = state => {

  const currentState = getCurrentState(state);
  const currentState_system = getSystemCurrentState(state);
  const users = currentState.ids.map(id => currentState.byId[id]);

  const loginUser = users.find(usr => usr.email === getUserId());
  //
  const adminUser = [],
    systemUser = [],
    subSystemUser = [],
    temp_subSystemUser = []

  // if (loginUser) {

  if (currentState_system.role === "system-user") {
    const userId = currentState_system.id
    users.map(usr => {
      if (usr.role === "system-user" && usr.id === userId) {
        systemUser.push(usr)
      }

      if (usr.role === "sub-system-user" && usr.parentId === userId) {
        subSystemUser.push(usr)
      }
    })

  } else {
    users.map(usr => {
      if (usr.role === "admin") {
        adminUser.push(usr)
      }

      if (usr.role === "system-user") {
        systemUser.push(usr)
      }

      if (usr.role === "sub-system-user") {
        temp_subSystemUser.push(usr)
      }
    })

    temp_subSystemUser.map(subUsr => {
      if (subUsr.parentId === null) {
        subSystemUser.push(subUsr)
      } else {
        const parentIndex = systemUser.findIndex(systemUsr => systemUsr.id === subUsr.parentId) + 1;
        systemUser.splice(parentIndex, 0, subUsr);
      }
    })
  }

  // }

  const sortUsers = adminUser.concat(systemUser).concat(subSystemUser)

  return sortUsers;
}

export const getIsSearching = state => getCurrentState(state).isSearching;

export const getIsSaving = state => getCurrentState(state).isSaving;

export const getIsDeactivating = state => getCurrentState(state).isDeactivating;

export const getIsActivating = state => getCurrentState(state).isActivating;

export const getSelectedUserId = state => getCurrentState(state).selectedUserId;

export const getCurrentUser = state => getCurrentState(state).currentUser;

export const getAllUsers = state => getCurrentState(state).byId;